import { ErrorText } from "components/errors/ErrorText";
import { InputHTMLAttributes } from "react";
import { UseFormRegister } from "react-hook-form";

interface IRegisterProps {
  register: UseFormRegister<any>;
  registerName: string;
  registerOpt?: any;
}

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  errorMessage?: string;
  labelClassname?: string;
  registerProps?: IRegisterProps;
}

export const CustomInput: React.FC<IProps> = (props) => {
  const {
    label,
    errorMessage,
    labelClassname,
    registerProps,
    className: inputClassName,
    ...inputProps
  } = props;

  return (
    <div className="custom-input">
      {label && (
        <label htmlFor={inputProps.id} className={labelClassname}>
          {label}
          {inputProps.required && <span className="text-danger"> *</span>}
        </label>
      )}

      {registerProps?.register ? (
        <input
          className={`form-control py-2 ${inputClassName}`}
          {...registerProps.register(
            registerProps.registerName,
            registerProps.registerOpt
          )}
          {...inputProps}
        />
      ) : (
        <input
          className={`form-control py-2 ${inputClassName}`}
          {...inputProps}
        />
      )}
      <ErrorText error={errorMessage} />
    </div>
  );
};
